module.exports = __webpack_public_path__ + "img/hill16.c85fb391.jpg";